import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const CortanaLogoBeckonInnerIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1024 299q100 0 193 26t173 73 147 113 113 146 73 174 26 193q0 100-26 193t-73 173-113 147-146 113-174 73-193 26q-100 0-193-26t-173-73-147-113-113-146-73-174-26-193q0-100 26-193t73-173 113-147 146-113 174-73 193-26z" />
    </svg>
  ),
  displayName: 'CortanaLogoBeckonInnerIcon',
});

export default CortanaLogoBeckonInnerIcon;
